export default __webpack_public_path__ + "static/media/energyicon.7e4aad2d.svg";